<div class="forgot-container">
  <div class="left-side">
    <div class="content-wrapper">
      <div class="message">
        <h1>Forgot Password?</h1>
      </div>
      <div class="image-wrap">
        <img src="assets/images/forgot-illustration.png" alt="Illustration of a user resetting their password" class="welcome-image" />
      </div>
    </div>
  </div>

  <div class="right-side">
    <div class="forgot-form-wrapper">
      <div class="logo-wrapper">
        <img src="assets/images/upspl_log.png" alt="UPSPL Company Logo" class="logo" />
      </div>

      <div *ngIf="successMessage" class="success-banner" role="alert" aria-live="polite">{{ successMessage }}</div>
      <div *ngIf="errorMessage" class="error-banner" role="alert" aria-live="polite">{{ errorMessage }}</div>

      <!-- EMAIL STEP -->
      <ng-container *ngIf="currentStep === 'email'">
        <button type="button" class="btn-back" (click)="currentStep = 'email'; emailForm.reset(); isResendDisabled = false;" *ngIf="false">Back</button>
        <div class="form-header">
          <p class="forgot-title">Enter your registered email to receive a One-Time Password (OTP) and reset your password securely.</p>
        </div>
        <form class="forgot-form" (ngSubmit)="onSubmitEmail()" [formGroup]="emailForm">
          <div class="form-group">
            <label for="email" class="form-label">Email Address</label>
            <input 
              type="email" 
              id="email" 
              formControlName="email" 
              placeholder="Enter work email"
              class="form-control" 
              autocomplete="email"
              [attr.aria-invalid]="emailForm.get('email')?.invalid"
              [attr.aria-describedby]="'email-error'"
            />
            <div id="email-error" *ngIf="emailForm.get('email')?.invalid && (emailForm.get('email')?.dirty || emailForm.get('email')?.touched)" class="error">
              <div *ngIf="emailForm.get('email')?.errors?.['required']">Email is required.</div>
              <div *ngIf="emailForm.get('email')?.errors?.['email']">Invalid email format.</div>
            </div>
          </div>
          <button type="submit" class="btn btn-send" [disabled]="isLoading">Send{{ isLoading ? 'ing...' : '' }}</button>
        </form>
      </ng-container>

      <!-- OTP STEP -->
      <ng-container *ngIf="currentStep === 'otp'">
        <button type="button" class="btn btn-back" (click)="currentStep = 'email'; otpForm.reset(); isResendDisabled = false;">Back</button>
        <div class="form-header">
          <p class="forgot-title">Check your email ({{email}}) and enter the 4-8 character code to continue. Code expires in 5 minutes.</p>
        </div>
        <form class="forgot-form" (ngSubmit)="onSubmitOtp()" [formGroup]="otpForm">
          <div class="form-group">
            <label for="otp" class="form-label">OTP</label>
            <input 
              type="text" 
              id="otp" 
              formControlName="otp" 
              placeholder="Enter 4-8 character code"
              class="form-control" 
              maxlength="8"
              inputmode="numeric"
              autocomplete="one-time-code"
              [attr.aria-invalid]="otpForm.get('otp')?.invalid"
              [attr.aria-describedby]="'otp-error'"
            />
            <div id="otp-error" *ngIf="otpForm.get('otp')?.invalid && (otpForm.get('otp')?.dirty || otpForm.get('otp')?.touched)" class="error">
              <div *ngIf="otpForm.get('otp')?.errors?.['required']">OTP is required.</div>
              <div *ngIf="otpForm.get('otp')?.errors?.['pattern']">OTP must be 4-8 alphanumeric characters.</div>
            </div>
          </div>
          <div class="resend-link">
            <a 
              (click)="resendOtp()" 
              class="resend" 
              [class.disabled]="isResendDisabled || isLoading"
              [attr.aria-disabled]="isResendDisabled || isLoading ? 'true' : null"
            >
              Didn't get it? {{ isResendDisabled ? 'Resend OTP in ' + resendCountdown + 's' : 'Resend OTP' }}
            </a>
          </div>
          <button type="submit" class="btn btn-verify" [disabled]="otpForm.invalid || isLoading">Verify{{ isLoading ? 'ing...' : '' }}</button>
        </form>
      </ng-container>

      <!-- PASSWORD STEP -->
      <ng-container *ngIf="currentStep === 'password'">
        <button type="button" class="btn btn-back" (click)="currentStep = 'otp'; resetForm.reset();">Back</button>
        <div class="form-header">
          <p class="forgot-title">Create a new password for your account. Make sure it's strong and easy to remember.</p>
        </div>
        <form class="forgot-form" (ngSubmit)="onSubmitReset()" [formGroup]="resetForm">
          <div class="form-group">
            <label for="password" class="form-label">New Password</label>
                <div class="password-wrapper">
                  <input
                    [type]="showNewPassword ? 'text' : 'password'"
                    id="password"
                    formControlName="password"
                    placeholder="New Password"
                    class="form-control"
                    autocomplete="new-password"
                    [attr.aria-invalid]="resetForm.get('password')?.invalid"
                    [attr.aria-describedby]="'password-error'"
                  />
                  <i
                    class="pi"
                    [ngClass]="showNewPassword ? 'pi-eye' : 'pi-eye-slash'"
                    (click)="toggleNewPassword()"
                  ></i>
                </div>

            <div id="password-error" class="password-hint">
              <small>Password must be at least 8 characters, include uppercase, lowercase, number, and symbol.</small>
            </div>
            <div *ngIf="resetForm.get('password')?.invalid && (resetForm.get('password')?.dirty || resetForm.get('password')?.touched)" class="error">
              <div *ngIf="resetForm.get('password')?.errors?.['required']">Password is required.</div>
              <div *ngIf="resetForm.get('password')?.errors?.['minlength']">Password must be at least 8 characters long.</div>
            </div>
          </div>
          <div class="form-group">
            <label for="confirmPassword" class="form-label">Confirm Password</label>
              <div class="password-wrapper">
                <input
                  [type]="showConfirmPassword ? 'text' : 'password'"
                  id="confirmPassword"
                  formControlName="confirmPassword"
                  placeholder="Confirm Password"
                  class="form-control"
                  autocomplete="new-password"
                  [attr.aria-invalid]="resetForm.get('confirmPassword')?.invalid"
                  [attr.aria-describedby]="'confirm-error'"
                />
                <i
                  class="pi"
                  [ngClass]="showConfirmPassword ? 'pi-eye' : 'pi-eye-slash'"
                  (click)="toggleConfirmPassword()"
                ></i>
              </div>

            <div id="confirm-error" *ngIf="resetForm.get('confirmPassword')?.invalid && (resetForm.get('confirmPassword')?.dirty || resetForm.get('confirmPassword')?.touched)" class="error">
              <div *ngIf="resetForm.get('confirmPassword')?.errors?.['required']">Confirmation is required.</div>
            </div>
            <div *ngIf="resetForm.errors?.['notSame']" class="error" id="match-error">Passwords do not match.</div>
          </div>
          <button type="submit" class="btn btn-reset" [disabled]="resetForm.invalid || isLoading">Reset{{ isLoading ? 'ting...' : '' }}</button>
        </form>
      </ng-container>
    </div>
  </div>
</div>